import {
    FETCH_MESSAGES,
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_FAILED,
    SEND_MESSAGE,
    STOP_FETCH_MESSAGES
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { RequestPushMsg } from '../other/NotificationFunctions';
import { onValue, push, off, child, get, ref } from "firebase/database";

export const fetchChatMessages = (bookingId) => (dispatch) => {

    const {
        chatRef
    } = firebase;
  
    dispatch({
        type: FETCH_MESSAGES,
        payload: bookingId,
    });
    onValue(chatRef(bookingId), snapshot => {
        if(snapshot.val()){
            let rootEntry = snapshot.val();
            let allMesseges = [];
            for (let key in rootEntry) {
                let entryKey = rootEntry[key]
                for (let msgKey in entryKey) {
                  entryKey[msgKey].smsId = msgKey
                  allMesseges.push(entryKey[msgKey])
                }
            }
            dispatch({
                type: FETCH_MESSAGES_SUCCESS,
                payload: allMesseges,
            });
        }else{
            dispatch({
                type: FETCH_MESSAGES_FAILED,
                payload: store.getState().languagedata.defaultLanguage.chat_not_found,
            });
        }
    })
};

export const sendMessage = (data) => (dispatch) => {

    const {
        chatRef
    } = firebase;

    const chatId = data.booking.customer + ','  + data.booking.driver
    var today = new Date();
    var time = today.getHours() + ":" + today.getMinutes();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); 
    var yyyy = today.getFullYear();
    today = mm + ':' + dd + ':' + yyyy;
    
    const msg = {
        message:data.message,
        from: data.role == 'customer'? data.booking.customer : data.booking.driver,
        type:"msg",
        msgDate:today,
        msgTime:time,
        createdAt: new Date().toString(),
        source: data.role
    };

    push(child(chatRef(data.booking.id), chatId), msg);

    if(data.role == 'customer'){
        if(data.booking.driver_token){
            RequestPushMsg(
                data.booking.driver_token,
                {
                    title: store.getState().languagedata.defaultLanguage.notification_title  + store.getState().languagedata.defaultLanguage.chat_requested,
                    msg: data.message,
                    screen: 'onlineChat',
                    params: { bookingId: data.booking.id }
                });
        }
    }else{
        if(data.booking.customer_token){
            RequestPushMsg(
                data.booking.customer_token,
                {
                    title: store.getState().languagedata.defaultLanguage.notification_title  + store.getState().languagedata.defaultLanguage.chat_requested,
                    msg: data.message,
                    screen: 'onlineChat',
                    params: { bookingId: data.booking.id}
                });
        }
    }

    dispatch({
        type: SEND_MESSAGE,
        payload: msg,
    });
}

// Chat Eats. Deux paires possibles sur une meme commande : client<->livreur
// (thread = order.id, historique) et restaurateur<->livreur (thread =
// order.id + '-restaurant', pour ne jamais melanger les deux conversations).
// fetchChatMessages/stopFetchMessages restent tels quels (generiques, juste
// une lecture/ecoute de chats/{threadId}/messages) ; sendMessage (VTC) est
// specifique a booking.customer/driver + tokens denormalises sur la
// reservation, absents des commandes Eats — le pushToken est recupere en
// direct sur l'utilisateur, et le restaurateur (compte web, pas de push
// mobile) est prevenu via son panneau de notifications existant.
export const sendEatMessage = (data) => (dispatch) => {

    const {
        chatRef,
        singleUserRef,
        database
    } = firebase;

    const order = data.order || {};
    const threadId = data.threadId || order.id;
    const roleUid = { customer: order.customerId, courier: order.courierId, restaurant: order.restaurantId };
    const fromId = roleUid[data.role] || data.role;
    const chatId = fromId + ',' + (roleUid[data.counterpartRole] || data.counterpartRole);

    var today = new Date();
    var time = today.getHours() + ":" + today.getMinutes();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    today = mm + ':' + dd + ':' + yyyy;

    const msg = {
        message: data.message,
        // Les regles Firebase exigent from === auth.uid pour autoriser
        // l'ecriture. customerId/courierId sont deja l'uid du compte, mais
        // restaurantId est un identifiant de fiche restaurant distinct de
        // l'uid du compte proprietaire (profile.restaurantId) : sans ce
        // fromUid explicite, chaque message envoye par un restaurateur etait
        // rejete en silence par les regles (push() sans catch), d'ou les
        // notifications recues mais des messages qui n'apparaissaient jamais.
        from: data.fromUid || fromId,
        type: "msg",
        msgDate: today,
        msgTime: time,
        createdAt: new Date().toString(),
        source: data.role
    };

    push(child(chatRef(threadId), chatId), msg).catch(error => {
        console.log('sendEatMessage write failed:', error && error.message ? error.message : error);
    });

    const recipientUid = roleUid[data.counterpartRole];
    if (data.counterpartRole === 'restaurant') {
        if (recipientUid && database) {
            push(ref(database, `eat/restaurantNotifications/${recipientUid}`), {
                title: 'Nouveau message livreur',
                msg: data.message,
                type: 'eat_chat',
                threadId,
                createdAt: Date.now(),
                read: false
            });
        }
    } else if (recipientUid && singleUserRef) {
        get(singleUserRef(recipientUid)).then(snapshot => {
            const recipient = snapshot && snapshot.exists() ? snapshot.val() : null;
            if (recipient && recipient.pushToken) {
                RequestPushMsg(
                    recipient.pushToken,
                    {
                        title: 'Allô Driver Eats',
                        msg: data.message,
                        screen: 'onlineChat',
                        params: {
                            bookingId: threadId,
                            status: order.status,
                            chatType: 'eat',
                            role: data.counterpartRole,
                            counterpartRole: data.role,
                            customerId: order.customerId,
                            courierId: order.courierId,
                            restaurantId: order.restaurantId
                        }
                    });
            }
        }).catch(() => {});
    }

    dispatch({
        type: SEND_MESSAGE,
        payload: msg,
    });
}

export const stopFetchMessages = (bookingId) => (dispatch) => {

    const {
        chatRef 
    } = firebase;

    dispatch({
        type: STOP_FETCH_MESSAGES,
        payload: bookingId,
    });
    off(chatRef(bookingId));
}